export default __webpack_public_path__ + "static/media/Progress.6295459e.svg";